<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu>
        
      </mobile-menu>
      <template slot="links">
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Dashboard', icon: 'dashboard', path: '/admin-dashboard' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Payment Dashboard', icon: 'money', path: '/admin-payment-dashboard' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Pricing', icon: 'money', path: '/admin-pricing-list' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Customers List', icon: 'group', path: '/admin-customer-list' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Payment History', icon: 'euro', path: '/admin-payment-history' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Payment Errors', icon: 'warning', path: '/admin-payment-errors' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Upcoming Expire Payment', icon: 'money', path: '/admin-upcoming-expire-payment-history' }"></sidebar-item>
        <sidebar-item v-if="role == 'SuperAdmin'" :link="{ name: 'Coupons', icon: 'euro', path: '/admin-coupons' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Notificatin List', icon: 'notifications', path: '/admin-custom-notifications' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Audit Logs', icon: 'history', path: '/admin-audit-logs' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Power Chat Users', icon: 'group', path: '/admin-power-chat-users' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Bloatware Appliations', icon: 'adb', path: '/admin-bloatware-apps' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Export List', icon: 'settings_backup_restore', path: '/admin-exports-list' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Blogs', icon: 'rss_feed', path: '/admin-blog-list' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Videos', icon: 'switch_video', path: '/admin-videos' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Faq', icon: 'quiz', path: '/admin-faq' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Contact Us', icon: 'contact_phone', path: '/admin-contactus' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Newsletters', icon: 'subscriptions', path: '/admin-newsletters' }"></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./SuperAdminTopNavbar.vue";
import ContentFooter from "./SuperAdminContentFooter.vue";
import MobileMenu from "./Extra/SuperAdminMobileMenu.vue";
//import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/SuperAdminUserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import UserDataService from "../../../../services/SuperAdmin/UsersDataService";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    //FixedPlugin,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      role: localStorage.getItem('adminRole'),
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    GetAdminDetail() {
      var data = {};
      UserDataService.getUserDetail(data)
        .then((response) => {
            this.role = response.data.data.role;
        })
        .catch((e) => {
          if (e.response.data.is_logout == 1) {
            localStorage.setItem('super_admin_token', "");            
              this.$router.push('super-admin/login');
            }
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  beforeMount(){
    //this.GetAdminDetail();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.md-title {
  font-weight: 500 !important;
}
</style>
